<template>
    <div>
        <div class="fridges-list">
            <div v-if="!hasFridges">
                Холодильники не найдены. Запросите список
            </div>
            <div v-if="hasFridges">
                <button class="btn btn-success fridge-btn" v-for="fridgeData in fridges" @click="selectFridge(fridgeData)">
                    {{fridgeData.department_id}}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import fridgeRabbit from '../utils/rabbit/fridge_rabbit';
    import _ from 'lodash';
    import {mapActions} from 'vuex';


    export default {
        name: "SelectFridge",
        computed: {
            hasFridges() {
                return this.fridges.length > 0;
            },
        },
        methods: {
            ...mapActions('app', {
                setSelectedFridge: 'setSelectedFridge',
            }),
            async askFridges() {
                this.fridges = [];
                await fridgeRabbit.listen(this.onFridgeAnswer, true);
                fridgeRabbit.send('ping', {}, true);
            },
            onFridgeAnswer(data) {
                console.log('onFridgeAnswer', data);

                if(data && data.department_id) {
                    let existIndex = _.findIndex(this.fridges, f => f.department_id == data.department_id);
                    if(existIndex > -1) {
                        this.fridges[existIndex] = data;
                    } else {
                        this.fridges.push(data);
                    }
                }
            },
            selectFridge(fridgeId) {
                this.setSelectedFridge(fridgeId);
                this.$router.push('/');
            },
        },
        data() {
            return {
                fridges: [],
            };
        },
        mounted() {
            this.askFridges();
        },
        destroyed() {
            fridgeRabbit.clear();
        },
    }
</script>

<style scoped>
    .fridges-list {
        margin-top: 20px;
        text-align: center;
    }
    .fridge-btn {
        margin: 2px;
        width: 30%;
        height: 100px;
        font-size: 1.7em;
    }
</style>